import { render } from "./Links.vue?vue&type=template&id=7b380ee3&scoped=true"
import script from "./Links.vue?vue&type=script&lang=js"
export * from "./Links.vue?vue&type=script&lang=js"

import "./Links.vue?vue&type=style&index=0&id=7b380ee3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/central-front/central-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b380ee3"]])

export default __exports__